import React, { createContext, useContext, useEffect, useState } from "react";
import { getCurrentUser, logout as logoutApi } from "../api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState({ authenticated: false });
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    setLoading(true);
    try {
      const user = await getCurrentUser();
      if (user && user.name) {
        setCurrentUser({
          authenticated: true,
          name: user.name,
          hasFamily: user?.hasFamily,
        });
      } else {
        setCurrentUser({ authenticated: false, name: "", hasFamily: false });
      }
    } catch (error) {
      setCurrentUser({ authenticated: false, name: "", hasFamily: false });
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    await logoutApi();
    setCurrentUser({ authenticated: false });
  };

  useEffect(() => {
    refreshUser();
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, refreshUser, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
